import { render } from "./mobile-payment-header.vue?vue&type=template&id=2e329620&scoped=true"
import script from "./mobile-payment-header.vue?vue&type=script&lang=js"
export * from "./mobile-payment-header.vue?vue&type=script&lang=js"

import "./mobile-payment-header.vue?vue&type=style&index=0&id=2e329620&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e329620"]])

export default __exports__